import React from "react";
import DateRangeSelector from "../../DateRangeSelector/DateRangeSelector";
import type { ControlledDateRangeSelectorInputProps } from "../../DateRangeSelector/types";
import FormInputWrapper from "./FormInputWrapper";

/** @deprecated */
const ControlledDateRangeSelectorInput = (
  props: ControlledDateRangeSelectorInputProps
) => (
  <FormInputWrapper
    {...props}
    as={DateRangeSelector}
  />
);

export default ControlledDateRangeSelectorInput;
